<mat-form-field subscriptSizing="dynamic">
    @if (ngControl?.control) {
        @if (textareaAutosize) {
            <textarea
                matInput
                [cdkTextareaAutosize]
                [cdkAutosizeMinRows]="autosizeMinRows"
                [cdkAutosizeMaxRows]="autosizeMaxRows"
                [placeholder]="placeholder"
                [formControl]="$any(ngControl!.control)"
                [errorStateMatcher]="errorMatcher"
                [attr.data-uiid]="dataUiid"
                (input)="onChange($event)"
            ></textarea>
        } @else {
            <textarea
                matInput
                [placeholder]="placeholder"
                [formControl]="$any(ngControl!.control)"
                [errorStateMatcher]="errorMatcher"
                [attr.data-uiid]="dataUiid"
                (input)="onChange($event)"
            ></textarea>
        }
    } @else {
        @if (textareaAutosize) {
            <textarea
                matInput
                [cdkTextareaAutosize]
                [cdkAutosizeMinRows]="autosizeMinRows"
                [cdkAutosizeMaxRows]="autosizeMaxRows"
                [disabled]="disabled"
                [placeholder]="placeholder"
                [ngModel]="value"
                [attr.data-uiid]="dataUiid"
                (input)="onChange($event)"
            ></textarea>
        } @else {
            <textarea
                matInput
                [disabled]="disabled"
                [placeholder]="placeholder"
                [ngModel]="value"
                [attr.data-uiid]="dataUiid"
                (input)="onChange($event)"
            ></textarea>
        }
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
